export default __webpack_public_path__ + "images/73e9d1eac6834282795f0593d3532d71.svg";